module.exports = __webpack_public_path__ + "assets/img/icon-3.9223b123.svg";